import { isChargingFeeCategory } from './usageFeeCategoryMatching';

const LEGACY_MANUAL_NOTE = 'Chốt phí thủ công';
const LEGACY_AUTO_NOTE = 'Chốt phí tự động';
const LEGACY_MANUAL_LABEL = 'Xe đăng ký mới (tính theo ngày đăng ký)';

export const CHARGING_INVOICE_NOTE_AUTO_PERIOD = 'Phí sạc trong kỳ (full tháng)';

export function formatManualChargingInvoiceNote(createdAt: Date | string): string {
  const date = typeof createdAt === 'string' ? new Date(createdAt) : createdAt;
  const ddMmYyyy = new Intl.DateTimeFormat('vi-VN', {
    timeZone: 'Asia/Ho_Chi_Minh',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
  return `Xe đăng ký mới (tính từ ngày ${ddMmYyyy})`;
}

function isStoredManualChargingRegistrationNote(stored: string): boolean {
  return (
    stored === LEGACY_MANUAL_NOTE ||
    stored === LEGACY_MANUAL_LABEL ||
    stored.startsWith('Xe đăng ký mới (tính từ ngày')
  );
}

export function resolveChargingInvoiceDisplayNote(invoice: {
  notes?: string | null;
  isAutoGenerated?: boolean | null;
  createdAt?: Date | string | null;
  usage?: number | null;
  feeCode?: string | null;
  categoryName?: string | null;
}): string | null {
  const category = {
    feeCode: invoice.feeCode,
    name: invoice.categoryName,
  };
  if (!isChargingFeeCategory(category)) {
    return null;
  }
  const stored = (invoice.notes ?? '').trim();
  if (invoice.isAutoGenerated) {
    if (
      !stored ||
      stored === LEGACY_AUTO_NOTE ||
      stored === CHARGING_INVOICE_NOTE_AUTO_PERIOD
    ) {
      return CHARGING_INVOICE_NOTE_AUTO_PERIOD;
    }
    return stored;
  }
  if (stored.startsWith('Xe đăng ký mới (tính từ ngày')) {
    return stored;
  }
  if (!stored || isStoredManualChargingRegistrationNote(stored)) {
    if (invoice.createdAt) {
      return formatManualChargingInvoiceNote(invoice.createdAt);
    }
    return LEGACY_MANUAL_LABEL;
  }
  if (stored === LEGACY_AUTO_NOTE) {
    return CHARGING_INVOICE_NOTE_AUTO_PERIOD;
  }
  return stored;
}

export function formatChargingInvoiceDetailLabel(invoice: {
  notes?: string | null;
  isAutoGenerated?: boolean | null;
  createdAt?: Date | string | null;
  feeCode?: string | null;
  categoryName?: string | null;
  usage?: number | null;
}): string | null {
  const note = resolveChargingInvoiceDisplayNote({
    ...invoice,
    usage: invoice.usage,
  });
  if (!note) return null;
  const usage =
    invoice.usage != null && invoice.usage > 0 ? ` · ${invoice.usage} xe` : '';
  return `${note}${usage}`;
}
